<template>
  <div class="zjmp da">
    <a-row type="flex"
           style="flex-wrap: nowrap">
      <a-col flex="0 0 auto"
             style="width: 500px">
        <div class="left">
          <div class="zjmp_t1">
            <expert-upload-view avatar-flag
                                ref="avatarUploadRef"
                                config-key="expert.apply.peoplePicture"
                                :refer-id="expertInfo.id" />
            <div class="info">
              <div class="r1">
                <span class="text1">{{ expertInfo.expertName }}</span>
                <span v-show="showDetail">
                  <span class="tag"
                        v-for="item in expertInfo.extras.tagInfos"
                        :style="'color:'+item.tagColor "
                        :key="item.id">{{ item.tagName }}</span>
                  <span class="tag v2"
                        v-if="expertInfo.emergencyFlag === '1'"><a-icon type="thunderbolt"
                            theme="filled" />{{
                      expertInfo.extras.emergencyFlagText
                    }}</span>
                </span>
              </div>
              <div class="text2">{{ expertInfo.idCard }}</div>
              <div class="text2">{{ expertInfo.mobilePhone }}
                <a @click="$emit('editPhone')"
                   v-show="showEditPhone">【更换】</a>
              </div>
              <div class="text2">{{ expertInfo.extras.areaAddressText }}</div>
              <div class="text2"
                   v-if="showState">
                状态：
                <a-tag color="#5DCC6F">{{ expertInfo.extras.stateText }}</a-tag>
              </div>
            </div>
          </div>
          <div class="zjmp_t2"></div>
          <slot name="content"></slot>
        </div>
      </a-col>
      <a-col style="width: 100%;overflow: auto">
        <div class="right">
          <a-tabs default-active-key="1">
            <a-tab-pane key="1"
                        tab="基本信息">
              <basic-info-view :expert-info="expertInfo" />
            </a-tab-pane>
            <a-tab-pane key="2"
                        tab="回避单位">
              <p>有<b style="color: red;font-size: 18px">{{ avoidUnitList.length }}</b>家回避单位</p>
              <div class="zjmp_t6">
                <a-tag v-for="item in avoidUnitList"
                       :key="item">{{ item }}
                </a-tag>
                <a-empty v-if="avoidUnitList.length === 0" />
              </div>
            </a-tab-pane>
            <a-tab-pane key="3"
                        tab="证明材料">
              <material-view :id="expertInfo.id"
                             ref="materialRef" />
            </a-tab-pane>
          </a-tabs>
        </div>
      </a-col>
    </a-row>
    <div class="btn_box">
      <slot name="action"></slot>
    </div>
  </div>
</template>

<script>
import MaterialView from '@/epp/expertmain/expertInfo/common/viewitem/MaterialView.vue'
import BasicInfoView from '@/epp/expertmain/expertInfo/common/viewitem/BasicInfoView.vue'
import ExpertUploadView from '@/components/selector/ExpertUploadView.vue'

export default {
  name: 'ExpertInfoDetailComponent',
  components: {
    MaterialView,
    BasicInfoView,
    ExpertUploadView
  },
  props: {
    showState: {
      type: Boolean,
      default: false
    },
    showDetail: {
      type: Boolean,
      default: false
    },
    showEditPhone: {
      type: Boolean,
      default: false
    },
    expertInfo: {
      type: Object,
      default: () => {
        return { extras: {} }
      }
    }
  },
  data () {
    return {
      record: {
        historyVisible: false,
        leaveVisible: false,
      }
    }
  },
  computed: {
    //回避单位
    avoidUnitList () {
      let unitList = this.expertInfo.unitName ? [this.expertInfo.unitName] : []
      unitList = unitList.concat(this.expertInfo.avoidUnit ? this.expertInfo.avoidUnit.split(',') : [])
      //单位去重
      unitList = [...new Set(unitList)]
      return unitList
    },
  },
  methods: {
    //刷新附件信息
    fileRefresh () {
      //头像刷新
      this.$refs.avatarUploadRef.refreshData()
      //其他附件刷新
      this.$refs.materialRef?.fileRefresh()
    }

  }

}
</script>

<style scoped lang="less">
.link {
  color: rgb(24, 144, 255);
}

.action button {
  margin-right: 4px;
}

.card {
  margin-bottom: 24px;

  .extras {
    font-weight: 500;
    font-size: 16px;
  }
}

.nav {
  .title {
    text-align: center;
    font-weight: 800;
  }

  .footer {
    text-align: right;
  }
}

.titleCap {
  margin-bottom: 12px;

  .receiveNum {
    padding-left: 16px;
  }

  > span {
    border-right: 1px solid #e6e6e6;
    padding: 0 20px;
  }

  > span:nth-last-child(1) {
    border-right: none;
  }

  > span:nth-child(2) {
    padding-left: 0;
  }
}
</style>
